/**
 *
 * @module searchExtensions
 *
 */

import Check from 'check-types';

import Exception from './../../services/exception/entry';
import GraphQlQuery from './../graphQlQuery';
import SearchOverrides from './../searchOverrides';
import SearchQuery from './searchQuery';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict,
    nonEmptyString
} = Check.assert;

/**
 *
 * @function SearchExtensions
 * @param {SDK.Content.ContentManager} ContentManager
 * @desc Adds extension methods onto the ContentManager prototype.
 *
 */
export default (ContentManager) => {

    /**
     *
     * @access public
     * @param {GraphQlQuery} query - Query to be used to retrieve content.
     * @param {SearchOverrides} [overrides] - Object that will override the default date and or location of the search
     * @param {String} [contentTransactionId] - An application developer-provided value to be included with the HTTP
     * request as the value of the `X-Content-Transaction-ID` header.
     * @returns {Promise<Object>} The GraphQL JSON returned from the search service.
     *
     */
    ContentManager.prototype.search = function (query, overrides, contentTransactionId) {

        const errorMessage = {
            method: 'SearchExtensions.search(query, overrides, contentTransactionId)',
            get query() {
                return `${this.method} needs GraphQlQuery instance`;
            },
            get overrides() {
                return `${this.method} overrides should be an instance of SDK.Content.SearchOverrides`;
            },
            get contentTransactionId() {
                return `${this.method} contentTransactionId should be a String with length`;
            }
        };

        instanceStrict(query, GraphQlQuery, errorMessage.query, InvalidArgumentException);

        if (Check.assigned(contentTransactionId)) {
            nonEmptyString(contentTransactionId, errorMessage.contentTransactionId, InvalidArgumentException);
        }

        if (Check.assigned(overrides)) {
            instanceStrict(overrides, SearchOverrides, errorMessage.overrides, InvalidArgumentException);
        }

        const searchQuery = new SearchQuery(query);

        return this.query({
            query: searchQuery,
            overrides,
            contentTransactionId
        });

    };

};



// WEBPACK FOOTER //
// ./src/content/search/searchExtensions.js